import { Component, OnInit } from '@angular/core';
import { UxService } from '~/app/core/services/ux.service';
import { ValidationService } from '~/app/core/services/validation.service';
import { Organization, Division } from '~/app/open-age/directory/models';
import { Organization as WelcomeOrganization } from '~/app/open-age/welcome/models/organization.model';
import { OrganizationService as WelcomeOrganizationService } from '~/app/open-age/welcome/services';
import { OrganizationService, DivisionService } from '~/app/open-age/directory/services';
import { Link } from '~/app/open-age/core/structures';
import { NavService } from '~/app/core/services';
import { ActivatedRoute } from '@angular/router';
import { PracticeService } from '~/app/open-age/telepain/services/practice.service';
import { timeZonesList } from '../../services/telepain/telepain.service';
import { EncryptionDecryptionService } from "../../services/encryptDecrypt/encryption-decryption.service";
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ValidatorsService } from '~/app/services/validators/validators.service';

@Component({
  selector: 'app-practice',
  templateUrl: './practice.component.html',
  styleUrls: ['./practice.component.css']
})
export class PracticeComponent implements OnInit {
  NAME_REGEX = /^[a-zA-Z ]+$/;
  PRACTICE_NAME_REGEX = /^[a-zA-Z0-9-',.& ]+$/;
  practice: Organization;
  welcomePractice: WelcomeOrganization;
  divisions: Division[];
  isProcessing: boolean;
  id: string;
  isCurrent = true;
  page: Link;
  states = ["Alabama (AL)", "Alaska (AK)", "Arizona (AZ)", "Arkansas (AR)", "California (CA)",
    "Colorado (CO)", "Connecticut (CT)", "Delaware (DE)", "District of Columbia (DC)",
    "Florida (FL)", "Georgia (GA)", "Hawaii (HI)", "Idaho (ID)", "Illinois (IL)",
    "Indiana (IN)", "Iowa (IA)", "Kansas (KS)", "Kentucky (KY)", "Louisiana (LA)",
    "Maine (ME)", "Marshall Islands (MH)", "Maryland (MD)", "Massachusetts (MA)",
    "Michigan (MI)", "Minnesota (MN)", "Mississippi (MS)", "Missouri (MO)", "Montana (MT)",
    "Nebraska (NE)", "Nevada (NV)", "New Hampshire (NH)", "New Jersey (NJ)", "New Mexico (NM)",
    "New York (NY)", "North Carolina (NC)", "North Dakota (ND)", "Ohio (OH)", "Oklahoma (OK)",
    "Oregon (OR)", "Pennsylvania (PA)", "Rhode Island (RI)", "South Carolina (SC)",
    "South Dakota (SD)", "Tennessee (TN)", "Texas (TX)", "Utah (UT)", "Vermont (VT)",
    "Virginia (VA)", "Washington (WA)", "West Virginia (WV)", "Wisconsin (WI)",
    "Wyoming (WY)"]
  timezones: any;
  practiceForm: FormGroup;

  constructor(
    private organizationService: OrganizationService,
    private errorHandler: UxService,
    private validator: ValidationService,
    private navService: NavService,
    private route: ActivatedRoute,
    private divisionService: DivisionService,
    private practiceService: PracticeService,
    private welcomeOrganizationService: WelcomeOrganizationService,
    private encryptDecryptService: EncryptionDecryptionService,
    private fb: FormBuilder,
    private validatorService: ValidatorsService
  ) {
  }

  ngOnInit() {
    this.timezones = timeZonesList;
    this.page = this.navService.register(`/practice/list/:id`, this.route, (isCurrent, params) => {
      this.id = params.get("id")
      this.isCurrent = isCurrent;
      if (this.isCurrent) {
        this.setContext();
      }
    });
    if (this.id) {
      this.isProcessing = true
      this.organizationService.get(this.id,{isDecrypt: true}).subscribe((item) => {
        this.practice = new Organization(item)
        this.practice.address.pinCode = this.toZipFormat(this.practice.address.pinCode)
        this.practiceForm = this.fb.group({
          name: [this.practice.name, [Validators.required, Validators.minLength(1),Validators.maxLength(70), Validators.pattern(this.PRACTICE_NAME_REGEX)]],
          email: [this.practice.email, [Validators.required,Validators.pattern(this.validatorService.patterns.email.pattern)]],
          phone: [this.practice.phone, [Validators.required, Validators.maxLength(12), Validators.minLength(12),Validators.pattern(/^\d{3}-\d{3}-\d{4}?$/)]],
          location: [this.practice.address.location, [Validators.required,Validators.minLength(this.validatorService.patterns.validString.minLength), Validators.maxLength(this.validatorService.patterns.validString.maxLength),Validators.pattern(this.validatorService.patterns.validString.pattern)]],
          line1: [this.practice.address.line1,[Validators.minLength(this.validatorService.patterns.addressLine.minLength),Validators.maxLength(this.validatorService.patterns.addressLine.maxLength),Validators.pattern(this.validatorService.patterns.addressLine.pattern)]],
          city: [this.practice.address.city, [Validators.required]],
          state: [this.practice.address.state, [Validators.required]],
          line2: [this.practice.address.line2,[Validators.minLength(this.validatorService.patterns.addressLine.minLength),Validators.maxLength(this.validatorService.patterns.addressLine.maxLength),Validators.pattern(this.validatorService.patterns.addressLine.pattern)]],
          pinCode: [this.practice.address.pinCode, [Validators.pattern(/^\d{5}(-\d{4})?$/),Validators.minLength(5), Validators.maxLength(10)]],
          // pinCode: [this.practice.address.pinCode, [Validators.maxLength(5), Validators.minLength(5),Validators.pattern(this.validatorService.patterns.validNumber.pattern)]],
          ein: [this.practice.meta.ein,[Validators.maxLength(9), Validators.minLength(9),Validators.pattern(this.validatorService.patterns.validNumber.pattern)]],
          fax: [this.practice.meta.fax, [Validators.maxLength(12), Validators.minLength(12), Validators.pattern(/^\d{3}-\d{3}-\d{4}?$/)]],
          timezoneOffset: [this.practice.timezoneOffset, [Validators.required]],
          divisions: this.fb.array([])
        });

        this.welcomeOrganizationService.get(this.practice.code).subscribe((item) => {
          this.welcomePractice = new WelcomeOrganization(item)
        }, (error) => {
        })
        this.practicePhoneNumberFormat(this.practice.phone)
        this.practiceFaxNumberFormat(this.practice.meta.fax)
        this.divisionService.search({ organization: item.id }, {isDecrypt: true}).subscribe(page => {
          this.divisions = page.items
          // this.divisions.forEach(division => this.addDivisionToForm(division));
          this.divisions.forEach((division, index) => {
            this.divisionPhoneNumberFormat(division.meta.phone, index); // formats and updates the phone
            division.address.pinCode = this.toZipFormat(division.address.pinCode)
            this.divisionFaxNumberFormat(division.meta.fax, index) // formats and updates the fax
            this.addDivisionToForm(division); // uses the updated phone value
          });
          this.isProcessing = false
        }, (error) => {
          this.errorHandler.handleError("Locations Not Found");
          this.isProcessing = false;
          this.back()
        })
        this.populatePracticeForm();
      }, (error) => {
        this.errorHandler.handleError("Practice Not Found");
        this.isProcessing = false;
        this.back()
      })
    } else {
      this.errorHandler.handleError("Practice Id Required");
      this.back()
    }
  }

  populatePracticeForm() {
    this.practiceForm.patchValue({
      name: this.practice.name,
      location: this.practice.address.location,
      ein: this.practice.meta.ein,
      line1: this.practice.address.line1,
      city: this.practice.address.city,
      state: this.practice.address.state,
      line2: this.practice.address.line2,
      pinCode: this.practice.address.pinCode,
      phone: this.practice.phone,
      email: this.practice.email,
      fax: this.practice.meta.fax,
      timezoneOffset: this.practice.timezoneOffset || null
    });
  }

  get divisionsFormArray(): FormArray {
    return this.practiceForm.get('divisions') as FormArray;
  }

  update() {
    if (this.practiceForm.invalid) {
      return;
    }

    const formValue = this.practiceForm.value;
    const ein = formValue.ein || "";
    const fax = formValue.fax || "";
    let timezone;
    this.practice.name = formValue.name;
    this.practice.email = formValue.email;
    this.practice.phone = formValue.phone.replace(/-/g, "");
    this.practice.timezoneOffset = formValue.timezoneOffset;
    this.practice.meta.fax = fax.replace(/-/g, "");
    this.practice.meta.ein = ein.replace(/-/g, "");
    this.practice.address.location = formValue.location;
    this.practice.address.city = formValue.city;
    this.practice.address.pinCode = formValue.pinCode;
    this.practice.address.state = formValue.state;
    this.practice.address.line1 = formValue.line1;
    this.practice.address.line2 = formValue.line2;
    if(this.practice.timezoneOffset) {
      const timeZoneObj = this.timezones.find(timeZone => timeZone.offset === this.practice.timezoneOffset)
      if(timeZoneObj) {
        timezone = timeZoneObj.timeZone
      }
    }
    this.practice.timezone = timezone;
    this.isProcessing = true
    this.updateDivisions().then(async() => {
      let data = await this.encryptDecryptService.encrypt(JSON.stringify(this.practice));
      this.organizationService.update(this.practice.id, {data: data},{isDecrypt: true}).subscribe((item) => {
        this.practice = item
        this.practicePhoneNumberFormat(this.practice.phone)
        this.practiceFaxNumberFormat(this.practice.meta.fax)
        this.errorHandler.showInfo("Practice Updated")
        this.isProcessing = false
      })
    }).catch((err) => {
      this.practicePhoneNumberFormat(this.practice.phone)
      if (this.practice.meta.fax) {
        this.practiceFaxNumberFormat(this.practice.meta.fax)
      }
      this.isProcessing = false
      // this.errorHandler.handleError(err.message || err)
    });
  }

  toZipFormat(input: number | string): string | null {
    const str = String(input).replace(/\D/g, '');

    if (str.length >= 9) {
      return `${str.slice(0, 5)}-${str.slice(5, 9)}`;
    }

    return null; // Not enough digits for ZIP+4
  }

  zipCodeCheck(event) {
    const allowedChars = /^[0-9-]+$/;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if(value.length == 5) {
      input.value = value + '-';
    }
  }


  addDivision() {
    this.divisionsFormArray.push(this.fb.group({
      name: ['', [Validators.required, Validators.minLength(this.validatorService.patterns.name.minLength),Validators.maxLength(this.validatorService.patterns.name.maxLength), Validators.pattern(this.validatorService.patterns.name.pattern)]],
      line1: ['',[Validators.minLength(this.validatorService.patterns.addressLine.minLength),Validators.maxLength(this.validatorService.patterns.addressLine.maxLength),Validators.pattern(this.validatorService.patterns.addressLine.pattern)]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      line2: ['',[Validators.minLength(this.validatorService.patterns.addressLine.minLength),Validators.maxLength(this.validatorService.patterns.addressLine.maxLength),Validators.pattern(this.validatorService.patterns.addressLine.pattern)]],
      // pinCode: ['', [Validators.maxLength(5), Validators.minLength(5),Validators.pattern(this.validatorService.patterns.validNumber.pattern)]],
      pinCode: ['', [Validators.pattern(/^\d{5}(-\d{4})?$/),Validators.minLength(5), Validators.maxLength(10)]],
      phone: ['', [Validators.required, Validators.maxLength(12), Validators.minLength(12), Validators.pattern(/^\d{3}-\d{3}-\d{4}$/)]],
      email: ['', [Validators.required,Validators.pattern(this.validatorService.patterns.email.pattern)]],
      fax: ['', [Validators.maxLength(12), Validators.minLength(12), Validators.pattern(/^\d{3}-\d{3}-\d{4}?$/)]],
      ein: ['',[Validators.maxLength(9), Validators.minLength(9),Validators.pattern(this.validatorService.patterns.validNumber.pattern)]],
    }));
  }

  addDivisionToForm(division: Division) {
    this.divisionsFormArray.push(this.fb.group({
      name: [division.name, [Validators.required, Validators.minLength(this.validatorService.patterns.name.minLength),Validators.maxLength(this.validatorService.patterns.name.maxLength), Validators.pattern(this.NAME_REGEX)]],
      email: [division.meta.email, [Validators.required,Validators.pattern(this.validatorService.patterns.email.pattern)]],
      phone: [division.meta.phone, [Validators.required, Validators.maxLength(12), Validators.minLength(12), Validators.pattern(/^\d{3}-\d{3}-\d{4}$/)]],
      line1: [division.address.line1,[Validators.minLength(this.validatorService.patterns.addressLine.minLength),Validators.maxLength(this.validatorService.patterns.addressLine.maxLength),Validators.pattern(this.validatorService.patterns.addressLine.pattern)]],
      city: [division.address.city, [Validators.required]],
      state: [division.address.state, [Validators.required]],
      line2: [division.address.line2,[Validators.minLength(this.validatorService.patterns.addressLine.minLength),Validators.maxLength(this.validatorService.patterns.addressLine.maxLength),Validators.pattern(this.validatorService.patterns.addressLine.pattern)]],
      // pinCode: [division.address.pinCode, [Validators.maxLength(5), Validators.minLength(5),Validators.pattern(this.validatorService.patterns.validNumber.pattern)]],
      pinCode: [division.address.pinCode, [Validators.pattern(/^\d{5}(-\d{4})?$/),Validators.minLength(5), Validators.maxLength(10)]],
      ein: [division.meta.ein,[Validators.maxLength(9),Validators.minLength(9),Validators.pattern(this.validatorService.patterns.validNumber.pattern)]],
      fax: [division.meta.fax, [Validators.maxLength(12), Validators.minLength(12), Validators.pattern(/^\d{3}-\d{3}-\d{4}?$/)]]
    }))
  }

  setContext() {
  }

  back() {
    this.navService.goto("/practice/list")
  }

  onlyNum(event) {
    if (isNaN(parseInt(event.key))) {
      return false;
    }
  }

  updateDivisions(): Promise<any> {
    return new Promise(async(resolve, reject) => {
      const formValue = this.practiceForm.value;
      if (formValue.divisions && formValue.divisions.length) {
        let i = formValue.divisions.length
        let index = 0
        for (const division of formValue.divisions) {
          const ein = division.ein || "";
          const fax = division.fax || "";
          let divisionObj = {
            name: division.name,

            address: {
              line1: division.line1,
              city : division.city,
              state: division.state,
              line2: division.line2,
              pinCode: division.pinCode,
            },
            meta: {
              email : division.email,
              phone: division.phone.replace(/-/g, ""),
              fax: fax.replace(/-/g, ""),
              ein: ein.replace(/-/g, ""),
            }
          }
          if(this.divisions.length) {
            if(this.divisions[index] && this.divisions[index].id) {
              divisionObj['id'] = this.divisions[index].id;
              divisionObj['code'] = this.divisions[index].code;
            } else {
              divisionObj['code'] = divisionObj.address.city + new Date().getTime()

            }
          }
          divisionObj['organization'] = this.practice
          index += 1
          if (divisionObj['id']) {
            let data = await this.encryptDecryptService.encrypt(JSON.stringify(divisionObj));
            this.divisionService.update(divisionObj['id'], {data: data},{isDecrypt: true}).subscribe(() => {
              // this.divisionPhoneNumberFormat(divisionObj.meta.phone, index)
              // this.divisionFaxNumberFormat(divisionObj.meta.fax, index)

            }, err => {
              // this.divisionPhoneNumberFormat(divisionObj.meta.phone, index)
              // this.divisionFaxNumberFormat(divisionObj.meta.fax, index)
            })
            --i
          } else {
            division.name = divisionObj.address.city
            division.code = divisionObj.address.city + new Date().getTime()
            let data = await this.encryptDecryptService.encrypt(JSON.stringify(divisionObj));
            this.divisionService.create({data: data},{isDecrypt: true}).subscribe(() => {
              // this.divisionPhoneNumberFormat(divisionObj.meta.phone, index)
              // this.divisionFaxNumberFormat(divisionObj.meta.fax, index)
            }, err => {
              // this.divisionPhoneNumberFormat(divisionObj.meta.phone, index)
              // this.divisionFaxNumberFormat(divisionObj.meta.fax, index)
            })
            --i
          }
        }
        if (i == 0) {
          resolve(true)
        }
      } else {
        resolve(true)
      }
    });
  };

  practiceFaxNumberFormat(mobile) {
    if (!mobile) {
      return
    }
    let phoneNumber = mobile
    let phoneNumberArray
    phoneNumber = phoneNumber.replace(/[^0-9]*/g, '')
    if (phoneNumber) {
      phoneNumberArray = phoneNumber.split('')
      phoneNumber = ''
      phoneNumberArray.forEach((item, i) => {
        if (i < 2) { phoneNumber = phoneNumber + item }
        if (i == 2) { phoneNumber = phoneNumber + item + '-' }
        if ((i < 5) && (i > 2)) { phoneNumber = phoneNumber + item }
        if (i == 5) { phoneNumber = phoneNumber + item + '-' }
        if (i > 5 && i < 11) { phoneNumber = phoneNumber + item }
      });
    }
    return this.practice.meta.fax = phoneNumber
  }

  practiceFaxFormat($event: any) {
    const mobile = $event.target.value;
    if (!mobile) {
      return
    }
    let phoneNumberArray
    let phoneNumber = mobile.replace(/[^0-9]*/g, '')
    if (phoneNumber) {
      phoneNumberArray = phoneNumber.split('')
      phoneNumber = ''
      phoneNumberArray.forEach((item, i) => {
        if (i < 2) { phoneNumber = phoneNumber + item }
        if (i == 2 && phoneNumberArray.length != 3) { phoneNumber = phoneNumber + item + '-' }
        if (i == 2 && phoneNumberArray.length == 3) { phoneNumber = phoneNumber + item }
        if ((i < 5) && (i > 2)) { phoneNumber = phoneNumber + item }
        if (i == 5 && phoneNumberArray.length != 6) { phoneNumber = phoneNumber + item + '-' }
        if (i == 5 && phoneNumberArray.length == 6) { phoneNumber = phoneNumber + item }
        if (i > 5 && i < 11) { phoneNumber = phoneNumber + item }
      });
    }

    if ([8].includes($event.keyCode) && [3, 6].includes(phoneNumberArray.length)) {
      phoneNumber = mobile.replace(/[^0-9]*/g, '')
    }

    if (phoneNumber) {
      this.practiceForm.controls['fax'].setValue(phoneNumber);
    }
  }

  practicePhoneNumberFormat(mobile) {
    if (!mobile) {
      return
    }
    let phoneNumber = mobile
    let phoneNumberArray
    phoneNumber = phoneNumber.replace(/[^0-9]*/g, '')
    if (phoneNumber) {
      phoneNumberArray = phoneNumber.split('')
      phoneNumber = ''
      phoneNumberArray.forEach((item, i) => {
        if (i < 2) { phoneNumber = phoneNumber + item }
        if (i == 2) { phoneNumber = phoneNumber + item + '-' }
        if ((i < 5) && (i > 2)) { phoneNumber = phoneNumber + item }
        if (i == 5) { phoneNumber = phoneNumber + item + '-' }
        if (i > 5 && i < 11) { phoneNumber = phoneNumber + item }
      });
    }
    return this.practice.phone = phoneNumber
  }

  divisionPhoneNumberFormat(mobile, index) {
    if (!mobile) {
      return
    }
    let phoneNumber = mobile
    let phoneNumberArray
    phoneNumber = phoneNumber.replace(/[^0-9]*/g, '')
    if (phoneNumber) {
      phoneNumberArray = phoneNumber.split('')
      phoneNumber = ''
      phoneNumberArray.forEach((item, i) => {
        if (i < 2) { phoneNumber = phoneNumber + item }
        if (i == 2) { phoneNumber = phoneNumber + item + '-' }
        if ((i < 5) && (i > 2)) { phoneNumber = phoneNumber + item }
        if (i == 5) { phoneNumber = phoneNumber + item + '-' }
        if (i > 5 && i < 11) { phoneNumber = phoneNumber + item }
      });
    }
    return this.divisions[index].meta.phone = phoneNumber
  }

  inputPhoneNumberFormat($event: any) {
    if($event.keyCode == 8) {
      return
    }
    const allowedChars = /^[0-9-]+$/;
    if (!allowedChars.test($event.key)) {
      $event.preventDefault();
    }
    const mobile = $event.target.value;
    if (!mobile) {
      return
    }
    if(mobile.length == 12) {
      return
    }
    let phoneNumber = mobile
    let phoneNumberArray
    phoneNumber = phoneNumber.replace(/[^0-9]*/g, '')
    if (phoneNumber) {
      phoneNumberArray = phoneNumber.split('')
      phoneNumber = ''
      phoneNumberArray.forEach((item, i) => {
        if (i < 2) { phoneNumber = phoneNumber + item }
        if (i == 2) { phoneNumber = phoneNumber + item + '-' }
        if ((i < 5) && (i > 2)) { phoneNumber = phoneNumber + item }
        if (i == 5) { phoneNumber = phoneNumber + item + '-' }
        if (i > 5 && i < 11) { phoneNumber = phoneNumber + item }
      });
    }
    const input = $event.target as HTMLInputElement;
    input.value = phoneNumber;
  }


  divisionFaxNumberFormat(mobile, index) {
    if (!mobile) {
      return
    }
    let phoneNumber = mobile
    let phoneNumberArray
    phoneNumber = phoneNumber.replace(/[^0-9]*/g, '')
    if (phoneNumber) {
      phoneNumberArray = phoneNumber.split('')
      phoneNumber = ''
      phoneNumberArray.forEach((item, i) => {
        if (i < 2) { phoneNumber = phoneNumber + item }
        if (i == 2) { phoneNumber = phoneNumber + item + '-' }
        if ((i < 5) && (i > 2)) { phoneNumber = phoneNumber + item }
        if (i == 5) { phoneNumber = phoneNumber + item + '-' }
        if (i > 5 && i < 11) { phoneNumber = phoneNumber + item }
      });
    }
    return this.divisions[index].meta.fax = phoneNumber
  }


  phoneNumberFormat($event) {
    const mobile = $event.target.value;
    if (!mobile) {
      return
    }
    let phoneNumberArray
    let phoneNumber = mobile.replace(/[^0-9]*/g, '')
    if (phoneNumber) {
      phoneNumberArray = phoneNumber.split('')
      phoneNumber = ''
      phoneNumberArray.forEach((item, i) => {
        if (i < 2) { phoneNumber = phoneNumber + item }
        if (i == 2 && phoneNumberArray.length != 3) { phoneNumber = phoneNumber + item + '-' }
        if (i == 2 && phoneNumberArray.length == 3) { phoneNumber = phoneNumber + item }
        if ((i < 5) && (i > 2)) { phoneNumber = phoneNumber + item }
        if (i == 5 && phoneNumberArray.length != 6) { phoneNumber = phoneNumber + item + '-' }
        if (i == 5 && phoneNumberArray.length == 6) { phoneNumber = phoneNumber + item }
        if (i > 5 && i < 11) { phoneNumber = phoneNumber + item }
      });
    }

    if ([8].includes($event.keyCode) && [3, 6].includes(phoneNumberArray.length)) {
      phoneNumber = mobile.replace(/[^0-9]*/g, '')
    }

    if (phoneNumber) {
      this.practiceForm.controls['phone'].setValue(phoneNumber);
    }
  }

}
